/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import stacheHelpers from 'helpers/client';
import urlUtil from 'scripts/utils/url';

export const QualifyingTabs = BaseControl.extend({
    init: function() {
        this._super();

        this.$element
            .find('.s-qualifying-tabs-inner--desktop')
            .append('<div class="s-promedica-sponsor-logo--desktop"></div>');
        this.$element
            .find('.s-qualifying-tabs')
            .after('<div class="s-promedica-sponsor-logo--mobile"></div>');

        this.$element.find('.s-qualifying-tabs-inner__item').each((i, el) => {
            const $el = this.$(el);
            const link = $el.find('a');

            if (
                (stacheHelpers.isActiveLink &&
                    stacheHelpers.isActiveLink(
                        link.attr('href'),
                        this.options.pagePath,
                        {},
                    )) ||
                (this.options.pageType == 'qualifying-sectional-event' &&
                    $el.hasClass('is-sectional'))
            ) {
                this.$(el).addClass('is-selected');
                this.element
                    .find(
                        '.s-qualifying-tabs-select option[value="' +
                            link.data('mobile-value') +
                            '"]',
                    )
                    .prop('selected', 'true');
                this.$(el).attr('aria-current', 'page');
            }

            return true;
        });
    },
    '.s-qualifying-tabs-inner--mobile .s-qualifying-tabs-select change': function(
        element,
        event,
    ) {
        let optionElement = element
            .closest('select')
            .find(
                'option.s-qualifying-tabs-select__option[value="' +
                    element.val() +
                    '"]',
            );
        window.location.href =
            urlUtil.getBaseUrl() + optionElement.attr('data-option-link');
    },
});
